import { ChainPath, IBlockchainEntity } from '@ankr.com/chains-list';

import { clearPathPrefix } from './clearPathPrefix';
import { mapSharkChainToChainPath } from './mapSharkChainNameToChainPath';

interface GetChainIdsByPathsParams {
  blockchains: IBlockchainEntity[];
  paths: ChainPath[];
}

export const getChainIDsByPaths = ({
  blockchains,
  paths,
}: GetChainIdsByPathsParams) => {
  const sharkPaths = paths.map(mapSharkChainToChainPath);

  return blockchains
    .filter(blockchain =>
      blockchain.paths?.some(path =>
        sharkPaths.includes(clearPathPrefix(path)),
      ),
    )
    .map(blockchain => blockchain.id);
};
